import { motion } from "framer-motion";

interface MetaInfoProps {
  title: string;
  tags: string[];
  link?: string;
}

export default function MetaInfo({ title, tags }: MetaInfoProps) {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20"
      variants={container}
      initial="hidden"
      animate="show"
      data-cy="meta-info"
    >
      <motion.div variants={item} className="backdrop-blur-sm bg-[rgba(30,12,50,0.2)] p-6 rounded-xl border border-[rgba(255,136,255,0.15)] shadow-glow-sm">
        <h3 className="text-[#ff88ff] text-sm font-medium mb-3 uppercase tracking-wider">PROJEKT</h3>
        <p className="text-white text-xl font-medium">{title}</p>
      </motion.div>

      <motion.div variants={item} className="backdrop-blur-sm bg-[rgba(30,12,50,0.2)] p-6 rounded-xl border border-[rgba(255,136,255,0.15)] shadow-glow-sm">
        <h3 className="text-[#ff88ff] text-sm font-medium mb-3 uppercase tracking-wider">TECHNOLOGIEN</h3>
        <div className="flex flex-wrap gap-2">
          {tags.map(tag => (
            <span
              key={tag}
              className="inline-block bg-[#1E0B32] border border-[#ff88ff]/20 px-2 py-1 rounded text-white/80 text-sm"
            >
              {tag}
            </span>
          ))}
        </div>
      </motion.div>

    </motion.div>
  );
}